import * as React from 'react'
import { ConfigClient } from './client'
import type { Adapters } from './types'

export interface ConfigProviderProps {
	client: ConfigClient
	children: React.ReactNode
	adapters?: Adapters | null
}

export const Context = React.createContext<ConfigClient | null>(null)

export function ConfigProvider({
	client,
	adapters,
	...rest
}: ConfigProviderProps) {
	const clientRef = React.useRef<ConfigClient>(undefined)
	const parentContext = React.useContext(Context)
	const adaptersRef = React.useRef<Adapters | null>(undefined)
	//

	React.useEffect(
		function setParentContextAdapters() {
			if (parentContext) {
				parentContext.setAdapters(adapters ?? null)
			}
		},
		[adapters, parentContext],
	)

	React.useEffect(
		function setClientAdapters() {
			if (adaptersRef.current === adapters) {
				return
			}
			adaptersRef.current = adapters

			client.setAdapters(adapters ?? null)
		},
		[adapters, client],
	)

	if (!parentContext && clientRef.current !== client) {
		clientRef.current = client

		if (client instanceof ConfigClient) {
			client.load()
		}
	}

	return <Context.Provider {...rest} value={parentContext ?? client} />
}
